/** FAQs for Earnings Insights freelancer landing (index-9). */
const freelancerEarningsFaqs = [
  {
    id: "earn-1",
    title: "What can I see in OracleMarket earnings insights?",
    desc: "You get live totals by client, currency, and payout rail, plus fee and FX impact so you know your true take-home on every invoice.",
  },
  {
    id: "earn-2",
    title: "Can I export data for my accountant?",
    desc: "Yes. Download CSV or connect your bookkeeping tool so deposits, withdrawals, and tax-relevant labels flow into the reports you already use.",
  },
  {
    id: "earn-3",
    title: "How far back does reporting go?",
    desc: "Standard history covers your full account lifetime. Filter by quarter, tax year, or custom ranges without losing line-item detail.",
  },
  {
    id: "earn-4",
    title: "Do insights include crypto and fiat in one view?",
    desc: "Balances and conversions roll into a single dashboard. You can still drill into each wallet or bank account when you need granular movement.",
  },
  {
    id: "earn-5",
    title: "Can I track recurring retainer income separately?",
    desc: "Tag clients or projects and save views for retainers, one-off gigs, or marketplace payouts so trends stay easy to compare.",
  },
  {
    id: "earn-6",
    title: "Will I get alerts when earnings spike or dip?",
    desc: "Optional thresholds notify you when weekly inflows cross a goal or fall below baseline—useful before you commit to new expenses.",
  },
];

export default freelancerEarningsFaqs;
